/**
 * SummaryKpiRow.jsx — 요약 KPI 카드 행
 *   총 콜 / 계약(신규) / 신규 상품별 장수 / 재주문 상품별 장수 / 총 장수
 *
 * TmSummary.jsx 에서 분리(300줄 규칙). 렌더 결과·동작은 분리 전과 동일합니다.
 * 모바일은 2열 grid, 신규·재주문만 전체폭(gridColumn '1 / -1')을 씁니다.
 */
import React from 'react';
import ScoreKpiCard from './ScoreKpiCard';

const labelStyle ={ fontSize: 11, color: 'var(--text-muted)', fontWeight: 500, marginBottom: 2 };
const unitStyle  = { fontSize: 12, fontWeight: 500, color: 'var(--text-muted)', marginLeft: 3 };

// 상품별 장수 묶음(신규/재주문 공용) — 색상과 라벨만 다르고 구조는 동일
function TicketBreakdown({ label, color, items, calLoading, isMobile }) {
  const bigNumStyle = { fontSize: isMobile ? 18 : 20, fontWeight: 800, color, lineHeight: 1 };
  return (
    <div style={isMobile ? { gridColumn: '1 / -1' } : {}}>
      <div style={{ ...labelStyle, marginBottom: 5 }}>{label}</div>
      {calLoading ? (
        <div style={bigNumStyle}>—</div>
      ) : items.length > 0 ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: isMobile ? '4px 12px' : 4, flexDirection: isMobile ? 'row' : 'column' }}>
          {items.map(({ name, count }) => (
            <div key={name} style={{ display: 'flex', alignItems: 'baseline', gap: 5 }}>
              <span style={{ fontSize: 12, color: 'var(--text-sub)', fontWeight: 500, whiteSpace: 'nowrap' }}>{name}</span>
              <span style={{ fontSize: isMobile ? 16 : 18, fontWeight: 800, color, lineHeight: 1 }}>{count.toLocaleString()}</span>
              <span style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-muted)' }}>장</span>
            </div>
          ))}
        </div>
      ) : (
        <div style={bigNumStyle}>
          0<span style={unitStyle}>장</span>
        </div>
      )}
    </div>
  );
}

export default function SummaryKpiRow({
  isMobile,
  loading,
  kpiLoading,
  calLoading,
  total,
  contractCount,
  newBreakdown,
  reorderBreakdown,
  totalTickets,
  renderTotalTicketsExtra,
  kpiData,
  scoreData,
  year,
  month,
}) {
  if (loading || kpiLoading) return null;

  return (
    <div style={{
      display: isMobile ? 'grid' : 'flex',
      gridTemplateColumns: isMobile ? '1fr 1fr' : undefined,
      gap: isMobile ? '12px 16px' : 24,
      marginTop: 14, paddingTop: 14, borderTop: '1px solid var(--border)',
    }}>
      <div>
        <div style={labelStyle}>총 콜</div>
        <div style={{ fontSize: isMobile ? 18 : 20, fontWeight: 800, color: 'var(--text)', lineHeight: 1 }}>
          {loading ? '—' : total}
          <span style={unitStyle}>건</span>
        </div>
      </div>
      <div>
        <div style={labelStyle}>계약</div>
        <div style={{ fontSize: isMobile ? 18 : 20, fontWeight: 800, color: '#10b981', lineHeight: 1 }}>
          {kpiLoading ? '—' : contractCount}
          <span style={unitStyle}>건</span>
        </div>
      </div>

      <TicketBreakdown label="신규"  color="#10b981" items={newBreakdown}     calLoading={calLoading} isMobile={isMobile} />
      <TicketBreakdown label="재주문" color="#f59e0b" items={reorderBreakdown} calLoading={calLoading} isMobile={isMobile} />

      {/* 총 장수: 외부(DOT/LNJ)=단순 합산, 파인그룹=상품 환산장수 기준 */}
      <div>
        <div style={labelStyle}>총 장수</div>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 3 }}>
          <span style={{ fontSize: isMobile ? 18 : 20, fontWeight: 800, color: '#6366f1', lineHeight: 1 }}>
            {kpiLoading ? '—' : totalTickets.toLocaleString()}
          </span>
          <span style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-muted)' }}>장</span>
        </div>
        {!kpiLoading && renderTotalTicketsExtra?.({ totalTickets, kpiData, year, month, isMobile })}
      </div>

      {/* 월간 점수 — 맨 오른쪽. 모바일에서는 총 장수 옆 빈칸에 들어가 행이 늘지 않는다. */}
      <ScoreKpiCard data={scoreData} year={year} month={month} isMobile={isMobile} />
    </div>
  );
}
